var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define('collections/organization/OrganizationCollection',['require','underscore','evertrue','ET/ETCollection','models/organization/OrganizationModel'],function(require) {
  var ETCollection, EverTrue, OrganizationCollection, OrganizationModel, _;
  _ = require("underscore");
  EverTrue = require("evertrue");
  ETCollection = require("ET/ETCollection");
  OrganizationModel = require("models/organization/OrganizationModel");
  return OrganizationCollection = (function(_super) {
    __extends(OrganizationCollection, _super);

    function OrganizationCollection() {
      return OrganizationCollection.__super__.constructor.apply(this, arguments);
    }

    OrganizationCollection.prototype.urlRoot = "auth/organizations/";

    OrganizationCollection.prototype.model = OrganizationModel;

    OrganizationCollection.prototype.parse = function(orgs) {
      var org_collection;
      org_collection = _.filter(orgs, function(org) {
        return !org.deleted;
      });
      org_collection = _.map(org_collection, function(org) {
        if (!org.name) {
          org.name = org.slug;
        }
        return org;
      });
      return org_collection;
    };

    OrganizationCollection.prototype.comparator = function(m1, m2) {
      if (m1.get("name") > m2.get("name")) {
        return 1;
      } else {
        return -1;
      }
    };

    return OrganizationCollection;

  })(ETCollection);
});

//# sourceMappingURL=OrganizationCollection.js.map
;
